import invariant from 'invariant';

import { isPointGeotype } from './isPointGeotype';

export enum RadiusType {
  state = 'state',
  country = 'country',
}

export const radiusStringToInt = (
  radius: RadiusType | string | null | undefined,
) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (radius) {
    case '':
      return null;
    case 'country':
      return -1;
    case 'state':
      return -2;
    default:
      invariant(radius, 'Search radius is null or undefined');
      return parseInt(radius, 10);
  }
};

export const radiusIntToString = (
  radius: number | null | undefined,
  geoType: string | null | undefined,
): RadiusType | string | undefined => {
  if (!radius && isPointGeotype(geoType)) {
    return '';
  }

  if (radius === -1) {
    return 'country';
  }

  if (radius === -2) {
    return 'state';
  }

  return radius ? String(radius) : undefined;
};
